<template>
  <b-modal
    :title="`Adicionar tarefa a ${workspace_name}`"
    centered
    v-model="openModal"
    no-close-on-backdrop
    hide-footer
    hide-header-close
    size="lg"
  >
    <!-- Formulario -->
    <validation-observer ref="FormSaveTask">
      <hr class="invoice-spacing mb-3" />
      <b-form>
        <b-row class="text-left mt-4">
          <b-col cols="12" md="6">
            <!-- PROJETOS -->
            <b-form-group class="mb-2">
              <label for="category" class="font-weight-bold text-primary"
                >Projetos :</label
              ><br />
              <label>
                <div
                  @click="handleShowArquived()"
                  :style="{
                    color: 'blue',
                    padding: '5px 0',
                    cursor: 'pointer',
                  }"
                >
                  {{
                    showArquivded ? 'Ocultar arquivados' : 'Mostrar arquivados'
                  }}
                </div></label
              >
              <validation-provider
                #default="{ errors }"
                :custom-messages="{ required: 'Este campo é obrigatório' }"
                rules="required"
              >
                <v-select
                  v-model="item.project_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Selecione..."
                  :options="projects"
                  @input="getProjectStages"
                  :reduce="(option) => option.id"
                  label="name"
                  class="mb-2"
                >
                  <div slot="no-options">
                    Desculpe, não existe projeto cadastrado!
                  </div>
                  <template
                    #list-header
                    v-if="
                      (userAccesses && userAccesses.is_admin) ||
                      (userAccesses && userAccesses.is_manager)
                    "
                  >
                    <li
                      class="add-new-header d-flex align-items-center my-50 cursor-pointer"
                      @click="$router.push({ name: 'novo-projeto' })"
                    >
                      <feather-icon icon="PlusIcon" size="16" />
                      <span class="align-middle ml-25">Add Novo Projeto</span>
                    </li>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group class="mb-2" v-if="item.project_id">
              <label
                for="category"
                class="font-weight-bold text-primary"
                style="margin-bottom: 35px"
                >Etapa do projeto :</label
              >
              <validation-provider
                #default="{ errors }"
                :custom-messages="{ required: 'Este campo é obrigatório' }"
                rules="required"
              >
                <b-form-select
                  v-model="item.project_stage_id"
                  :options="project_stages"
                  value-field="id"
                  text-field="stage_name"
                  placeholder="Selecione uma etapa"
                ></b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <!-- TITULO -->
            <b-form-group
              class="mb-2"
              v-if="
                currentWorkspace && currentWorkspace.complete_workspace == false
              "
            >
              <label class="font-weight-bold text-primary"
                >Tipo de tarefa:</label
              >
              <b-form-input v-model="item.title"></b-form-input>
            </b-form-group>

            <div class="w-100 mb-2" v-else>
              <label class="font-weight-bold text-primary"
                >Tipo de tarefa:</label
              >
              <!-- Garante que o v-select ocupe a largura total -->
              <validation-provider
                #default="{ errors }"
                :custom-messages="{ required: 'Este campo é obrigatório' }"
                rules="required"
              >
                <v-select
                  v-model="item.selected_task_title"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Selecione"
                  :options="task_title_arr"
                  :reduce="(option) => option.id"
                  label="name"
                >
                  <div slot="no-options">
                    Desculpe, mas o projeto não tem etapa!
                  </div>
                  <template #list-header>
                    <li
                      class="add-new-header d-flex align-items-center my-50 cursor-pointer"
                      @click="$router.push({ name: 'novo-titulo-tarefa' })"
                    >
                      <feather-icon icon="PlusIcon" size="16" />
                      <span class="align-middle ml-25"
                        >Add Novo tipo de tarefa</span
                      >
                    </li>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="4">
            <!-- DATA DE REFERÊNCIA -->
            <b-form-group class="mb-2" :disabled="item.isRepeatActive">
              <label for="referenceDate" class="font-weight-bold text-primary"
                >Data :</label
              >
              <validation-provider
                #default="{ errors }"
                :custom-messages="{ required: 'Este campo é obrigatório' }"
                rules="required"
              >
                <b-form-input
                  id="referenceDate"
                  type="date"
                  v-model="item.date"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <!-- HORA DE INÍCIO -->
            <b-form-group class="mb-2">
              <label for="startTime" class="font-weight-bold text-primary"
                >Hora de Início:</label
              >
              <validation-provider
                #default="{ errors }"
                :custom-messages="{ required: 'Este campo é obrigatório' }"
                rules="required"
              >
                <b-form-input
                  maxlength="5"
                  id="startTime"
                  type="time"
                  value="09:20"
                  v-model="item.start"
                  @input="item.start = formatHour($event)"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <!-- HORA DE FIM -->
            <b-form-group class="mb-2">
              <label for="endTime" class="font-weight-bold text-primary"
                >Hora de Fim:</label
              >
              <validation-provider
                #default="{ errors }"
                :custom-messages="{ required: 'Este campo é obrigatório' }"
                rules="required"
              >
                <b-form-input
                  maxlength="5"
                  id="endTime"
                  type="time"
                  v-model="item.end"
                  @input="item.end = formatHour($event)"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <!-- Descricao -->
            <b-form-group class="mb-2">
              <label class="font-weight-bold text-primary">Descriçao:</label>
              <b-form-textarea v-model="item.notes"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="4">
            <label for="" class="font-weight-bold text-primary"
              >Prioridade da tarefa:</label
            >
            <b-form-select
              id=""
              v-model="item.priority"
              :options="priorityOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um projeto"
              class="mb-2"
            ></b-form-select>
          </b-col>
          <b-col cols="12" md="4">
            <label for="" class="font-weight-bold text-primary"
              >Custo da tarefa:

              <feather-icon
                v-b-tooltip.hover.lefttop.v-primary.html
                :title="`<div style='text-align: left;'><b>NIVEL ESTRATÉGICO:</b> Direção Executiva, Conselho Adm, Diretores, VP. <br><br>
                  <b>NÍVEL TATICO:</b> Gerentes de departamentos, Coordenadores de projeto, Equipe de planejamento.<br><br>
                  <b>NÍVEL OPERACIONAL:</b> Equipes de trabalho, Supervisores, Lideres de equipe, Colaboradores.</div>`"
                icon="InfoIcon"
                size="15"
                style="cursor: pointer"
              />
            </label>
            <b-form-select
              id=""
              v-model="item.cost"
              :options="costOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um custo"
              class="mb-2"
            ></b-form-select>
          </b-col>
          <b-col cols="12" md="4">
            <label for="" class="font-weight-bold text-primary"
              >Risco da tarefa:
              <feather-icon
                v-b-tooltip.hover.lefttop.v-primary.html
                :title="`<div style='text-align: left;'><b>NIVEL ESTRATÉGICO:</b> Direção Executiva, Conselho Adm, Diretores, VP. <br><br>
                  <b>NÍVEL TATICO:</b> Gerentes de departamentos, Coordenadores de projeto, Equipe de planejamento.<br><br>
                  <b>NÍVEL OPERACIONAL:</b> Equipes de trabalho, Supervisores, Lideres de equipe, Colaboradores.</div>`"
                icon="InfoIcon"
                size="15"
                style="cursor: pointer"
              />
            </label>
            <b-form-select
              id=""
              v-model="item.risk"
              :options="riskOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um custo"
              class="mb-2"
            ></b-form-select>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6">
            <label for="" class="font-weight-bold text-primary"
              >Estado da tarefa:</label
            >
            <b-form-select
              id=""
              v-model="item.status"
              :options="statusOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um estado"
              class="mb-2"
            ></b-form-select>
          </b-col>
          <b-col cols="12" md="6">
            <label for="" class="font-weight-bold text-primary"
              >Nível de tarefa:
              <feather-icon
                v-b-tooltip.hover.lefttop.v-primary.html
                :title="`<div style='text-align: left;'><b>NIVEL ESTRATÉGICO:</b> Direção Executiva, Conselho Adm, Diretores, VP. <br><br>
                  <b>NÍVEL TATICO:</b> Gerentes de departamentos, Coordenadores de projeto, Equipe de planejamento.<br><br>
                  <b>NÍVEL OPERACIONAL:</b> Equipes de trabalho, Supervisores, Lideres de equipe, Colaboradores.</div>`"
                icon="InfoIcon"
                size="15"
                style="cursor: pointer"
            /></label>
            <b-form-select
              id=""
              v-model="item.level"
              :options="levelOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um nível"
              :disabled="userAccesses && userAccesses.is_common"
              class="mb-2"
            ></b-form-select>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6">
            <label for="" class="font-weight-bold text-primary"
              >Retrabalho:</label
            >
            <b-form-select
              id=""
              v-model="item.rework"
              :options="reworkOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um nível"
              class="mb-2"
            ></b-form-select>
          </b-col>
          <b-col cols="12" md="6">
            <label for="" class="font-weight-bold text-primary"
              >Trabalho remoto:</label
            >
            <b-form-select
              id=""
              v-model="item.remote"
              :options="remoteOptions"
              value-field="value"
              text-field="name"
              placeholder="Selecione um nível"
              class="mb-2"
            ></b-form-select>
          </b-col>
        </b-row>

        <hr class="invoice-spacing" />
      </b-form>
    </validation-observer>

    <!-- Botoes -->
    <b-row class="justify-content-around p-2">
      <b-col cols="12" md="6">
        <!-- back -->
        <b-button
          variant="warning"
          class="mr-2 mb-2 w-100"
          @click="$emit('closeModal')"
          >Voltar
        </b-button>
      </b-col>

      <b-col cols="12" md="6">
        <!-- back -->
        <b-button @click="saveTask" class="mr-2 w-100" variant="primary"
          >Salvar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { required } from '@validations';

import {
  BModal,
  BForm,
  BRow,
  BFormGroup,
  BFormSelect,
  BButton,
  BFormInput,
  BFormTextarea,
  VBTooltip,
  BCol,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
//import moment from 'moment';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  name: 'new-task',
  props: {
    pre_time: { type: Object, require: false },
    open: {
      type: Boolean,
      default: false,
    },
    costs_variables: { type: Object, require: false },
    required,
  },
  components: {
    BModal,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormInput,
    BFormTextarea,
  },

  data() {
    return {
      showArquivded: false,
      workspace_name: '',
      openModal: this.open,
      project_stages: [],
      task_title_arr: [],
      priorityOptions: [
        { name: 'Baixa', value: 'Baixa' },
        { name: 'Média', value: 'Media' },
        { name: 'Alta', value: 'Alta' },
      ],
      reworkOptions: [
        { name: 'Sim', value: true },
        { name: 'Não', value: false },
      ],
      remoteOptions: [
        { name: 'Sim', value: true },
        { name: 'Não', value: false },
      ],
      costOptions: [
        { name: 'Baixo Custo', value: 'baixa' },
        { name: 'Medio Custo', value: 'media' },
        { name: 'Alto Custo', value: 'alta' },
      ],
      riskOptions: [
        { name: 'Baixo Risco', value: 'baixa' },
        { name: 'Medio Risco', value: 'media' },
        { name: 'Alto Risco', value: 'alta' },
      ],
      statusOptions: [
        { name: 'PREVISTA', value: 'PREVISTA' },
        { name: 'EM EXECUÇÃO', value: 'EM EXECUÇÃO' },
        { name: 'EM PAUSA', value: 'EM PAUSA' },
        { name: 'CONCLUÍDA', value: 'CONCLUÍDA' },
        { name: 'CANCELADA', value: 'CANCELADA' },
      ],
      levelOptions: [
        { name: 'ESTRATÉGICO', value: 'estrategico' },
        { name: 'TÁTICO', value: 'tatic' },
        { name: 'OPERACIONAL', value: 'operacional' },
      ],
      item: {
        project_id: null,
        title: '',
        date: null,
        start: '',
        end: '',
        notes: '',
        direct_cost: '0',
        real_direct_cost: '0',
        indirect_cost: 0,
        real_indirect_cost: '0',
        selected_task_title: '',
        priority: 'Baixa',
        risk: 'baixa',
        cost: 'baixa',
        rework: false,
        remote: false,
        status: 'EM EXECUÇÃO',
        level: 'operacional',
      },
      member_id: '',
      projects: [],
      loading: false,
    };
  },

  created() {
    this.getMemberId();
    this.getProjects();
    if (
      this.currentWorkspace &&
      this.currentWorkspace.complete_workspace == true
    ) {
      this.getAllTaskTitles();
    }
    this.workspace_name = this.currentWorkspace.workspace_title;
  },

  computed: {
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
    currentUser() {
      return this.$store.getters.user.accesses.find(
        (a) => a.workspace_id == this.$store.getters.currentWorkspace.id,
      );
    },
    userAccesses() {
      return this.$store &&
        this.$store.getters &&
        this.$store.getters.userAccesses
        ? this.$store.getters.userAccesses
        : null;
    },
  },

  watch: {
    open(newVal) {
      this.openModal = newVal;
    },
    openModal(newVal) {
      if (!newVal) {
        this.$emit('update:open', false);
      }
    },
    pre_time: {
      handler(newPreTime) {
        this.item.start = this.transformNumberInHour(newPreTime.start);
        this.item.date = this.dateFormatter(newPreTime.date, 'yyyy-MM-dd');
        this.item.end = this.transformNumberInHour(newPreTime.end);
      },
      deep: true,
    },
  },

  methods: {
    async getAllTaskTitles() {
      this.task_title_arr = [];

      this.$store
        .dispatch('getAllTaskTitles', {
          workspace_id: this.currentWorkspace.id,
          page: 1,
          perPage: 1000,
          inactive: false,
        })
        .then((resp) => {
          resp.data.map((item) => {
            let obj = {
              id: item.id,
              name: item.task_title.toUpperCase(),
            };
            this.task_title_arr.push(obj);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getProjectStages() {
      this.project_stages = [];
      this.$store
        .dispatch('getProjectStages', {
          project_id: this.item.project_id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          this.project_stages = resp.map((item) => ({
            id: item.id,
            stage_name: item.stage_name,
          }));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getMemberId() {
      this.$store
        .dispatch('getUserMember', {
          id: this.$store.getters.user.id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          this.member_id = resp[0].member_id;
          this.hour_per_month =
            resp[0] && resp[0].member ? resp[0].member.hour_per_month : 0;

          let wage =
            resp && resp[0] && resp[0].member && resp[0].member.cost_per_month
              ? resp[0].member.cost_per_month
              : 0;
          let unproductively =
            resp && resp[0] && resp[0].member && resp[0].member.unproductively
              ? resp[0].member.unproductively
              : 0;

          const wageSafe = Number(wage) || 0;
          const unproductivelySafe = Number(unproductively) || 0;
          const hourPerMonthSafe = Number(this.hour_per_month) || 0;
          this.direct_cost =
            wageSafe && hourPerMonthSafe
              ? Math.floor(
                  (wageSafe * (100 - unproductivelySafe)) /
                    hourPerMonthSafe /
                    100,
                )
              : 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async saveTask() {
      this.$refs.FormSaveTask.validate().then((success) => {
        if (success) {
          const startTime = this.item.start.split(':');
          const endTime = this.item.end.split(':');

          const startDate = new Date();
          startDate.setHours(startTime[0], startTime[1]);

          const endDate = new Date();
          endDate.setHours(endTime[0], endTime[1]);

          if (endDate <= startDate) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Hora de fim deve ser maior que a hora de início',
                icon: 'ErrorIcon',
                variant: 'danger',
              },
            });
            return;
          }

          this.item.start = this.transformInCompleteData(this.item.start);
          this.item.end = this.transformInCompleteData(this.item.end);

          const duration = (endDate - startDate) / (1000 * 60 * 60);
          const proportionalDirectCost = parseInt(this.direct_cost * duration);

          this.$store
            .dispatch('saveMyTask', {
              ...this.item,
              direct_cost: proportionalDirectCost,
              indirect_cost: parseInt(
                this.costs_variables.average_office_cost * duration,
              ),
              data: this.item.start,
              member_id: this.member_id,
              workspace_id: this.$store.getters.currentWorkspace.id,
              workspace_complete: this.currentWorkspace.workspace_complete,
              created_by: this.member_id,
            })
            .then((resp) => {
              if (resp) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Tarefa cadastrada com sucesso',
                    icon: 'SuccessIcon',
                    variant: 'success',
                  },
                });

                this.item = {
                  project_id: null,
                  title: '',
                  date: null,
                  start: '',
                  end: '',
                  notes: '',
                  direct_cost: '0',
                  real_direct_cost: '0',
                  indirect_cost: '0',
                  real_indirect_cost: '0',
                };
                this.$emit('closeModal');
              }
            })
            .catch((err) => {
              const errorMessage =
                err.response?.data?.message ||
                err.message ||
                'An unexpected error occurred';
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: 'ErrorIcon',
                  variant: 'danger',
                },
              });
            });
        }
      });
    },
    async getProjects() {
      let body = {
        id: this.$route.params.id,
        workspace_id: this.$store.getters.currentWorkspace.id,
        perPage: 1000,
      };
      this.$store
        .dispatch('_getProjects', this.formatQueryParams(body))
        .then((resp) => {
          resp.data.map((e) => {
            if (this.showArquivded) {
              this.projects.push({
                id: e.id,
                name: `${e.project_code} - ${e.project_name} ${
                  e.is_archived ? '(Arquivado)' : ''
                }`,
              });
            } else {
              if (e.is_archived) {
                return null;
              } else {
                this.projects.push({
                  id: e.id,
                  name: `${e.project_code} - ${e.project_name} ${
                    e.is_archived ? '(Arquivado)' : ''
                  }`,
                });
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    transformNumberInHour(numero) {
      if (numero >= 0 && numero <= 23) {
        const horasFormatadas = numero < 10 ? `0${numero}` : `${numero}`;
        return `${horasFormatadas}:00`;
      } else {
        return 'Número inválido. Por favor, insira um número de 0 a 23.';
      }
    },

    transformInCompleteData(hour) {
      const dataAtual = new Date(this.item.date);
      dataAtual.setDate(dataAtual.getDate() + 1);
      dataAtual.setHours(hour.split(':')[0]);
      dataAtual.setMinutes(hour.split(':')[1]);

      return this.dateFormatter(dataAtual, 'yyyy-MM-dd HH:mm:ss');
    },

    formatHour(hour) {
      const [hours, minutes] = hour.split(':');
      if (parseInt(minutes) > 59) {
        return `${hours}:59`;
      }
      return hour;
    },
    handleShowArquived() {
      this.showArquivded = !this.showArquivded;
      this.projects = [];
      this.getProjects();
    },
  },
};
</script>

<style></style>
